import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import Buefy from "buefy";
import "/sass/buefy-overwrite.scss";
import AsyncComputed from "vue-async-computed";
import VueSocialSharing from "vue-social-sharing";
import VueLazyload from "vue-lazyload";
import "./registerServiceWorker";

Vue.use(VueLazyload, {
  loading: require("@/assets/loading.gif")
});
Vue.use(VueSocialSharing);
Vue.use(AsyncComputed);
Vue.use(Buefy);
Vue.use(Vuex);

Vue.config.productionTip = false;

const store = new Vuex.Store({
  state: {
    selected: -1,
    language: "en",
    mapVisible: true,
    focus: false,
    audioPlayState: false,
    currentAudio: null
  },
  mutations: {
    setAudioPlayState(state, playing) {
      state.audioPlayState = playing;
    },
    setAudioObject(state, obj) {
      state.currentAudio = obj;
    },
    setSelected(state, index) {
      state.selected = index;
    },
    setLanguage(state, language) {
      state.language = language;
    },
    setMapVisibility(state, visibility) {
      state.mapVisible = visibility;
    },
    setFocus(state, focused) {
      state.focus = focused;
    }
  }
});

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
